import React from 'react';
import { useSelector } from 'react-redux';
import FormMultiSelect from 'shared/formControls/FormMultiSelect';
import FormSelect from 'shared/forms/FormSelect';
import { getWarehouseCCCCommodities } from 'src/slices/warehouseCCCCommodities';

const CCCCommodityDropdown = (props) => {

    const commodities = useSelector(getWarehouseCCCCommodities).map(({ id, commodity }) => ({ description: commodity, value: id }));
    const value = typeof props.value === 'object' ? props.value : commodities.find(x => x.value == props.value);

    const SelectComponent = props.multiSelect ? FormMultiSelect : FormSelect;
    return (
        <SelectComponent
            data={commodities}
            dataItemKey={props.dataItemKey || 'value'}
            textField={props.textField || 'description'}
            clearButton={true}
            {...props}
            value={value}
        />
    );
};

export default CCCCommodityDropdown;